export default "__VITE_ASSET__amYCYq3C__"